/* apps/viewer/src/app/news/news-list/news-list.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host o-card-news {
  display: block;
  margin-bottom: 20px;
}
:host .actions {
  display: flex;
  justify-content: flex-end;
  margin: 5px 0;
}
:host .no-news {
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=news-list.component.css.map */
